import styles from './Footer.module.css'

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <span className={styles.copy}>
          Made with <span className={styles.heart}>&hearts;</span> by the
          Fantasy Console 0 Team
        </span>
      </div>
    </footer>
  )
}
